// import '@babel/polyfill'
import 'whatwg-fetch'
import Vue from 'vue'

Vue.config.productionTip = false

Vue.component('product-page-filter-component', require('./components/product-page-filter-component.vue').default);
Vue.component('product-page-filterdialog-component', require('./components/product-page-filterdialog-component.vue').default);
Vue.component('product-page-pagination-component', require('./components/product-page-pagination-component.vue').default);
Vue.component('search-page-component', require('./components/search-page-component.vue').default);
Vue.component('product-page-component', require('./components/product-page-component.vue').default);
Vue.component('search-bar-component', require('./components/search-bar-component.vue').default);
Vue.component('product-row-component', require('./components/product-row-component.vue').default);
Vue.component('product-search-page-component', require('./components/product-search-page-component.vue').default);
Vue.component('attribute-search-page-component', require('./components/attribute-search-page-component.vue').default);
Vue.component('subscribe-back-instock-dialog-component', require('./components/subscribe-back-instock-dialog-component.vue').default);

window.Vue = Vue;